import { ConnectButton } from '@rainbow-me/rainbowkit';

function WalletConnectBtn() {
  return (
    <ConnectButton.Custom>
      {({
        account,
        chain,
        openAccountModal,
        openChainModal,
        openConnectModal,
        authenticationStatus,
        mounted,
      }) => {

        const ready = mounted && authenticationStatus !== 'loading';
        const connected =
          ready &&
          account &&
          chain &&
          (!authenticationStatus ||
            authenticationStatus === 'authenticated');

        return (
          <div className='flex justify-end items-center w-[300px] h-[6vh] text-[2xl]'
            {...(!ready && {
              'aria-hidden': true,
              'style': {
                opacity: 0,
                pointerEvents: 'none',
                userSelect: 'none',
              },
            })}
          >
            {(() => {
              if (!connected) {
                return (
                  <div className='flex flex-row md:gap-2 px-2 lg:w-[300px] stakeContainer h-[40px] rounded-[10px] md:text-[2xl] text-[14px] justify-center items-center cursor-pointer hover:opacity-80 transition-all duration-500' onClick={openConnectModal}>
                    <img src="/wallet.svg" alt="wallet-icon" />
                    <h2 className='text-center'>
                      Connect Wallet
                    </h2>
                  </div>
                );
              }

              if (chain.unsupported) {
                return (
                  <button className='stakeContainer rounded-[10px]' onClick={openChainModal} type="button">
                    Wrong network
                  </button>
                );
              }

              return (
                <div className='flex justify-center items-center h-[4vh] gap-5'>
                  <button className='w-0 opacity-0 md:opacity-100 md:w-[120px] h-[40px] px-2 stakeContainer flex justify-center items-center focus:outline-none rounded-[10px] hover:opacity-80 transition-all duration-500'
                    onClick={openChainModal}
                    style={{ display: 'flex', alignItems: 'center' }}
                    type="button"
                  >
                    {chain.hasIcon && (
                      <div
                        style={{
                          background: chain.iconBackground,
                          width: 12,
                          height: 12,
                          borderRadius: 999,
                          overflow: 'hidden',
                          marginRight: 4,
                        }}
                      >
                        {chain.iconUrl && (
                          <img
                            alt={chain.name ?? 'Chain icon'}
                            src={chain.iconUrl}
                            style={{ width: 12, height: 12 }}
                          />
                        )}
                      </div>
                    )}
                    {chain.name}
                  </button>
                  <button className='h-[40px] md:w-[200px] rounded-[10px] px-2 focus:outline-none stakeContainer hover:opacity-80 transition-all duration-500' onClick={openAccountModal} type="button">
                    {account.displayName}
                    {account.displayBalance
                      ? ` (${account.displayBalance})`
                      : ''}
                  </button>
                </div>
              );
            })()}
          </div>
        );
      }}
    </ConnectButton.Custom>
  )
}

export default WalletConnectBtn